import { ChangeDetectionStrategy, Component, Input, input, OnInit } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../../../../../components/state/state.component';
import { IFormBettings, IFormConfig, ITeamsMetadata, ITournamentGeneralBetting, ITournamentGeneralFormConfig, UnderOver } from '@oogaday/shared';
import { UntypedFormGroup } from '@angular/forms';
import { IBettingOption, IDropdownConfig } from '../common/model/betting.model';
import { OptionsProviderService } from '../common/services/options-provider.service';
import { ButtonGroupBettingComponent } from '../common/components/button-group-betting/button-group-betting.component';
import { DropdownsBettingComponent } from '../common/components/dropdowns-betting/dropdowns-betting.component';
import { MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';


@Component({
  selector: 'oo-tournament-general-form-filler',
  templateUrl: './tournament-general-form-filler.component.html',
  styleUrls: ['./tournament-general-form-filler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent, DropdownsBettingComponent, ButtonGroupBettingComponent],
})
export class TournamentGeneralFormFillerComponent extends StateComponent<TournamentGeneralFormFillerComponentState> implements OnInit {


  readonly metadata = input.required<ITeamsMetadata>();

  state: TournamentGeneralFormFillerComponentState = {
    status: 'ready',
    config: null!,
    betting: undefined,
    bettingForm: null!,
    isSubmissionMode: false,
    winnerOptions: [],
    bestGoalScorerOptions: [],
    mostGoalsInMatchOptions: [],
    teamsToReachFinalsOptions: [],
    fastestGoalOptions: [],
    bestGoalScorerGoalsOptions: [],
    underOverOptions: [],
  };


  @Input() set config(config: IFormConfig) {
    this.updateState({ config: config as ITournamentGeneralFormConfig });
  }

  @Input() set bettingForm(bettingForm: UntypedFormGroup) {
    this.updateState({ bettingForm });
  }

  @Input() set betting(betting: IFormBettings<any> | undefined) {
    this.updateState({ betting });
  }

  @Input() set isSubmissionMode(isSubmissionMode: boolean) {
    this.updateState({ isSubmissionMode });
  }

  ngOnInit(): void {
    this.updateState({
      winnerOptions: this.getWinnerOptions(),
      bestGoalScorerOptions: OptionsProviderService.getBestGoalScorerOptions(this.metadata().teams),
      mostGoalsInMatchOptions: OptionsProviderService.getRangeOptions(),
      teamsToReachFinalsOptions: OptionsProviderService.getTeamsOptions('Teams to reach the finals', this.metadata().teams),
      fastestGoalOptions: OptionsProviderService.fastestGoalOptions(),
      bestGoalScorerGoalsOptions: OptionsProviderService.getRangeOptions(),
      underOverOptions: this.state.config.betsConfig.underOver ? OptionsProviderService.getUnderOverOptions(this.state.config.betsConfig.underOver.goals) : undefined,
    });
  }

  private getWinnerOptions(): IDropdownConfig[] {
    return [
      {
        label: `Select a winner`,
        options: this.metadata().teams.map((team) => ({
          value: team.id,
          name: team.name,
          subtitle: this.state.config.betsConfig.winner.odds[team.id] ? ` (${this.state.config.betsConfig.winner.odds[team.id]})` : '',
        })),
      },
    ];
  }
}

interface TournamentGeneralFormFillerComponentState {
  status: ComponentStatus;
  config: ITournamentGeneralFormConfig;
  betting: ITournamentGeneralBetting | undefined;
  bettingForm: UntypedFormGroup;
  isSubmissionMode: boolean;
  winnerOptions: IDropdownConfig[];
  bestGoalScorerOptions: IDropdownConfig[];
  mostGoalsInMatchOptions: IDropdownConfig[];
  teamsToReachFinalsOptions: IDropdownConfig[];
  fastestGoalOptions: IDropdownConfig[];
  bestGoalScorerGoalsOptions: IDropdownConfig[];
  underOverOptions: IBettingOption<UnderOver>[];
}
